<template>
  <div class="more-modal" ref="moreModal">
    <div class="more-modal-close">
      <span @click="$emit('close')">
        <SvgElement name="close-icon" />
      </span>
    </div>

    <div>
      <div class="more-modal-option">
        <div class="more-modal-title">
          <SvgElement name="share-icon" />
          Share this poll
        </div>
        <div class="more-modal-action">
          <span class="text-button" @click="copyLink()"> Copy Link </span>
          <span class="more-modal-feedback">Link copied</span>
        </div>
      </div>
      <div class="more-modal-option">
        <div class="more-modal-title">
          <SvgElement name="embed-icon" />
          Embed this poll
        </div>
        <div class="more-modal-action">
          <span class="text-button" @click="copyEmbedCode($event)">
            Copy Code
          </span>
          <span class="more-modal-feedback">Embed code copied</span>
        </div>
      </div>
      <div class="more-modal-option">
        <div class="more-modal-title">
          <SvgElement name="hide-icon" />
          Opt-out
        </div>
        <div class="more-modal-action">
          <span class="text-button" @click="deleteResponses($event)">
            Delete My Responses
          </span>
          <span class="more-modal-feedback"
            >The responses were deleted successfully</span
          >
        </div>
      </div>

      <div
        class="more-modal-option"
        v-if="globals.userInfo && !globals.userInfo.contactVerified"
      >
        <div class="more-modal-title">
          <SvgElement name="user-icon" />
          {{ globals.userInfo.email }}
        </div>
        <div class="more-modal-action">
          <span
            class="text-button"
            @click="
              $emit('close');
              setGlobals('userInfoNeeds', 'verify');
              setGlobals('state', 'signup');
            "
          >
            Complete Sign-up
          </span>
          or
          <span class="text-button" @click="onLogOut()"> Logout </span>
        </div>
      </div>

      <div
        class="more-modal-option"
        v-else-if="globals.userInfo && !globals.userInfo.username"
      >
        <div class="more-modal-title">
          <SvgElement name="user-icon" />
          {{ globals.userInfo.email }}
        </div>
        <div class="more-modal-action">
          <span
            class="text-button"
            @click="
              $emit('close');
              onShowSidePanel(debate);
              setSidePanelTab('complete-signup');
            "
          >
            Complete Sign-up
          </span>
          or
          <span class="text-button" @click="onLogOut()"> Logout </span>
        </div>
      </div>

      <div
        class="more-modal-option"
        v-else-if="userIsVerified && !globals.userInfo"
      >
        <div class="more-modal-title">
          <SvgElement name="user-icon" />
          {{ getCookie(globals.verifiedUserCookieName, true) }}
        </div>
        <div class="more-modal-action">
          <span
            class="text-button"
            @click="
              $emit('close');
              onShowSidePanel(debate);
              setSidePanelTab('complete-signup');
            "
          >
            Complete Sign-up
          </span>
          or
          <span class="text-button" @click="onLogOut()"> Logout </span>
        </div>
      </div>

      <div class="more-modal-option" v-else-if="globals.userInfo">
        <div class="more-modal-title">
          <div
            v-if="globals.userInfo"
            class="profile-photo"
            @click="openProfile(null, true)"
          >
            <figure :style="{ borderColor: globals.userInfo.statusColor }">
              <img
                v-if="globals.userInfo && globals.userInfo.avatarObject"
                :src="globals.userInfo.avatarObject.thumb.location"
              />
              <div
                v-for="role in globals.userInfo.roles"
                v-bind:key="role.name"
              >
                <span
                  v-if="role.name === 'VERIFIED'"
                  class="checkmark"
                  :style="{
                    backgroundColor: globals.userInfo.checkmarkColor,
                  }"
                >
                  <SvgElement name="check-icon" />
                </span>
              </div>
            </figure>
          </div>

          {{ globals.userInfo.name }}
        </div>
        <div class="more-modal-action">
          {{ globals.userInfo.email }}
          <span class="text-button" @click="onLogOut()"> logout</span>
        </div>
      </div>

      <div class="more-modal-option" v-else>
        <div class="more-modal-title">
          <SvgElement name="user-icon" />
          Sign in
        </div>
        <div class="more-modal-action">
          <span
            class="text-button"
            @click="
              $emit('close');
              initLogin();
            "
          >
            Login
          </span>
          or
          <span
            class="text-button"
            @click="
              $emit('close');
              initSignup();
            "
          >
            Sign up
          </span>
        </div>
      </div>
    </div>

    <div class="more-modal-powered">
      Powered by Sided. v1.1
      <a
        class="text-button no-underline"
        href="https://sided.co/privacy-policy"
        target="_blank"
        >{{ $t("Privacy Policy") }}</a
      >.
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SvgElement from "./SvgElement";

export default {
  name: "MoreModal",
  inject: [
    "globals",
    "onLogOut",
    "getCookie",
    "initLogin",
    "initSignup",
    "loadDebate",
    "setGlobals",
    "debateHolder",
    "debateHistory",
    "userIsVerified",
    "copyToClipboard",
    "onShowSidePanel",
    "setSidePanelTab",
    "refreshDebateHistory",
  ],
  data() {
    return {
      embedCode:
        '<script type="text/javascript" src="https://cdn.sided.co/embed-assets/load.min.js" async><//script>',
    };
  },
  props: {
    debate: {
      type: Object,
      default: null,
    },
  },
  components: {
    SvgElement,
  },
  methods: {
    getLink() {
      return `${window.location.href.replace(window.location.hash, "")}#${
        this.debateHolder.id
      }`;
    },
    copyLink() {
      const feedback = event.target.parentNode.querySelector(
        ".more-modal-feedback",
      );
      feedback.style.visibility = "visible";
      this.copyToClipboard(this.getLink());

      setTimeout(() => feedback.removeAttribute("style"), 1000);
    },
    copyEmbedCode(event) {
      const feedback = event.target.parentNode.querySelector(
        ".more-modal-feedback",
      );
      feedback.style.visibility = "visible";
      this.copyToClipboard(this.embedCode);

      setTimeout(() => feedback.removeAttribute("style"), 1000);
    },
    deleteResponses(event) {
      const feedback = event.target.parentNode.querySelector(
        ".more-modal-feedback",
      );
      feedback.style.visibility = "visible";

      axios
        .delete(
          `/user/deleteVotes?fingerprint=${this.globals.deviceId}&clientId=${this.debate.clientId}`,
        )
        .then(() => {
          this.loadDebate(null, true);
          this.refreshDebateHistory();
        });

      setTimeout(() => feedback.removeAttribute("style"), 1500);
    },
  },
  mounted() {
    axios.get(`/debate/getEmbed/${this.debate.id}`).then(({ data }) => {
      this.embedCode = (this.embedCode + data.data.html).replace(
        "//script",
        "script",
      );
    });
  },
};
</script>
